import manager from 'app/module46/component-manager.js';

console.log('registering submission-form');
manager.register('submission-form', submissionForm);

/**
 * @param {HTMLFormElement} component
 * @param {Object.<string, Element>} references
 * @param {Array.<Element>} references.errors
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function submissionForm(component, references, attributes, properties) {


	const submissionTable = document.getElementById('submission-table')

	const inputs = submissionTable.querySelectorAll('input');

	console.log(inputs);

	[].forEach.call(inputs, function(input) {
		// do whatever
		const hiddenInput = document.createElement("input");
		hiddenInput.setAttribute("type", "hidden");
		hiddenInput.setAttribute("name", input.name);
		hiddenInput.setAttribute("value", input.value);
		component.appendChild(hiddenInput);
	});
}
